module.exports = __webpack_public_path__ + "media/images/home/mini/3-d93f6f78e7e8629c3cc4fad441e19a63.png";